import { gql } from '@apollo/client';

export const GET_BIDQUOTE_ITEMS_BY_TYPE = gql`
query GetBidQuoteItemsByType($BidQuoteId: uniqueidentifier = "", $Type: String = "") {
    BidQuoteItems(where: {BidQuoteId: {_eq: $BidQuoteId}, Type: {_eq: $Type}}) {
      Id
      Segment
      ParentBidQuoteItemId
    }
}`;